import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'products/nomad_insurance/components/Select';
import {
  COUNTRY_OPTIONS,
  US_STATE_OPTIONS
} from 'products/nomad_insurance/components/Select/consts';
import TextInput from 'products/nomad_insurance/components/TextInput';
import { Container, CustomCountrySelect, Header, Row } from './styled';

const BillingAddress = ({ formik, variant = 'fountainBlue', className }) => {
  useEffect(() => {
    if (formik.values?.address?.country !== 'US') return;
    if (
      !US_STATE_OPTIONS.map((item) => item.label).includes(formik.values?.address?.state)
    ) {
      formik.setFieldValue('address.state', '');
    }
  }, [formik.values?.address?.country, formik.values?.address?.state]);

  return (
    <Container className={className}>
      <Header>Billing address</Header>
      <TextInput label="Address" formik={formik} name="address.line1" variant={variant} />
      <Row>
        <TextInput label="City" name="address.city" formik={formik} variant={variant} />
        {formik.values?.address?.country === 'US' ? (
          <Select
            label="State"
            name="address.state"
            options={US_STATE_OPTIONS}
            formik={formik}
            variant={variant}
          />
        ) : (
          <TextInput
            label="State (optional)"
            name="address.state"
            formik={formik}
            variant={variant}
          />
        )}
      </Row>
      <Row>
        <CustomCountrySelect
          showFlag
          label="Country"
          options={COUNTRY_OPTIONS}
          name="address.country"
          formik={formik}
          variant={variant}
        />
        <TextInput
          label="Postal Code"
          name="address.zipCode"
          formik={formik}
          variant={variant}
        />
      </Row>
    </Container>
  );
};

BillingAddress.propTypes = {
  formik: PropTypes.object,
  variant: PropTypes.string,
  className: PropTypes.string
};

export default BillingAddress;
